export default __webpack_public_path__ + "static/360-4242058fd52cd4f6acaa3e539e3d2276.gif";